import React from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import PropTypes from "prop-types";
import {Icone} from "../Icone";
import {BOTAO, ICONE} from "../../config/constantes/constantes";
import {getClasse} from "../index";

export function Botao (props) {
        const cor = !props.cor ? "primary" : props.cor;
        const tamanho = !props.tamanho ? BOTAO.TAMANHO.MEDIO : props.tamanho;
        const margem = !props.margem ? "m-0" : "m-"+props.margem;
        const temSpinner = !props.temSpinner ? true : props.temSpinner
        const spinner = (props.carregando && temSpinner) ? (
                <Spinner
                    className="ml-2"
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                />
            ) : "";
        const margemIcone = !!props.children;
        return(
            <Button
                variant={cor}
                className={getClasse(props.className)+tamanho+margem}
                disabled={props.carregando || props.disabled}
                onClick={props.onClick}
            >
                {props.icone ? <Icone margem={margemIcone} icone={props.icone} /> : ''}
                {props.children}
                {spinner}
            </Button>
        )
}
Botao.propTypes = {
    cor: PropTypes.string,
    tamanho: PropTypes.string,
    margem: PropTypes.string,
    icone: PropTypes.string,
    carregando: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    onClick: PropTypes.func,
    temSpinner: PropTypes.bool,
    variant: PropTypes.string,
    children: PropTypes.any,
}

const protoTipo = {
    onClick: PropTypes.func,
    tamanho: PropTypes.string
}

export function BotaoAlterar (props) {
    return(<Botao icone={ICONE.TIPO.ALTERAR} cor={BOTAO.COR.ALERTA} tamanho={props.tamanho} margem={props.margem} onClick={props.onClick} {...props}>Alterar</Botao>);
}
BotaoAlterar.propTypes = protoTipo;

export function BotaoEnviar (props) {
    return(<Botao icone={ICONE.TIPO.ENVIAR} cor={BOTAO.COR.PRIMARIO} tamanho={props.tamanho} margem={props.margem} onClick={props.onClick} {...props}>Enviar</Botao>);
}
BotaoEnviar.propTypes = protoTipo

export function BotaoImprimir (props) {
    return(<Botao icone={ICONE.TIPO.IMPRIMIR} cor={BOTAO.COR.SECUNDARIO} tamanho={props.tamanho} margem={props.margem} onClick={props.onClick} {...props}>Imprimir</Botao>);
}
BotaoImprimir.propTypes = protoTipo

export function BotaoFechar (props) {
    return(<Botao icone={ICONE.TIPO.FECHAR} cor={BOTAO.COR.SECUNDARIO} tamanho={props.tamanho} margem={props.margem} onClick={props.onClick} {...props}>Fechar</Botao>);
}
BotaoFechar.propTypes = protoTipo

export function BotaoSalvar (props) {
    return(<Botao icone={ICONE.TIPO.SALVAR} cor={BOTAO.COR.SUCESSO} tamanho={props.tamanho} margem={props.margem} onClick={props.onClick} {...props}>Salvar</Botao>);
}
BotaoSalvar.propTypes = protoTipo

export function BotaoExcluir (props) {
    return(<Botao icone={ICONE.TIPO.EXCLUIR} cor={BOTAO.COR.PERIGO} tamanho={props.tamanho} margem={props.margem} onClick={props.onClick} {...props}>Excluir</Botao>);
}
BotaoExcluir.propTypes = protoTipo

export function BotaoPesquisar (props) {
    return(<Botao icone={ICONE.TIPO.PESQUISAR} cor={BOTAO.COR.PRIMARIO} tamanho={props.tamanho} margem={props.margem} onClick={props.onClick} {...props}>Pesquisar</Botao>);
}
BotaoPesquisar.propTypes = protoTipo

export function BotaoAdicionar (props) {
    return(<Botao icone={ICONE.TIPO.ADICIONAR} cor={BOTAO.COR.PRIMARIO} tamanho={props.tamanho} margem={props.margem} onClick={props.onClick} {...props}>Adicionar</Botao>);
}
BotaoPesquisar.propTypes = protoTipo
